export default __webpack_public_path__ + "static/media/logo.c6622fd9.png";